"use client";

import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { getHomeMarqueeWords } from "../home.data";

type HomeMarqueeSectionProps = {
  variant: "forward" | "reverse";
};

// * ─── Scrolling Marquee Band ─────────────────────────────────────────────────
export function HomeMarqueeSection({ variant }: HomeMarqueeSectionProps) {
  const { t } = useTranslation("common");
  const marqueeWords = getHomeMarqueeWords(t);
  const isForward = variant === "forward";

  return (
    <section className="relative px-0 sm:px-0 lg:px-0">
      <div className="relative">
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-walnut-100/20 to-transparent dark:via-walnut-900/20" />
        <div className={isForward ? "rotate-[2deg]" : "rotate-[-2deg]"}>
          <div className="overflow-hidden py-10">
            <motion.div
              className="flex items-center gap-10 whitespace-nowrap text-2xl sm:text-3xl md:text-4xl font-bold text-walnut-800 dark:text-walnut-200"
              animate={{ x: isForward ? ["-50%", "0%"] : ["0%", "-50%"] }}
              transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
            >
              {[...marqueeWords, ...marqueeWords].map((word, idx) => (
                <span key={idx} className="inline-flex items-center gap-6">
                  <span>{word}</span>
                  <span
                    aria-hidden
                    className="block w-2 h-2 rounded-full bg-walnut-500/70 dark:bg-walnut-400/70"
                  />
                </span>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
